<script setup lang="ts">
import KontoinformationForm from '@/components/kontoinformation-form.vue'
import { Gesuch } from '@/models/Gesuch'

const {
    readOnly = false,
    gesuch = null,
    loading = false,
} = defineProps<{
    readOnly?: boolean
    gesuch?: Gesuch | null
    loading?: boolean
}>()
</script>

<template>
    <v-container fluid>
        <KontoinformationForm :gesuch="gesuch" :loading="loading" :read-only="readOnly" />
        <v-card class="centered-card mt-5" variant="flat">
            <v-card-actions>
                <v-spacer />
                <v-btn
                    variant="flat"
                    class="mt-2"
                    color="action"
                    :loading="loading"
                    @click="$emit('next', null)"
                    append-icon="fas fa-arrow-right"
                >
                    {{ $t('next_step') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-container>
</template>
